module.exports = __webpack_public_path__ + "img/catalogNavIcon.8c379ca7.svg";